import { Badge } from "@components/ui/badge";
import { endpoint } from "@services/api.services";
import Tooltip from "@ui/external/components/tooltip";
import { useHandleAction } from "@utils/hook/index.hook";
import { ColumnType } from "@utils/interface/index.interface";
import { RoleData } from "@utils/interface/journey.interface";
import { useSelectionStore } from "@utils/states/index.state";
import { useMemo } from "react";
interface CloumnListProps {
  refetch?: () => void;
}
const ColumnList = ({ refetch }: CloumnListProps) => {
  const journeyEndpoint = useMemo(() => endpoint["journey"], []);
  const { clearSelection } = useSelectionStore();
  const { handleAction } = useHandleAction({
    endpoint: journeyEndpoint,
    refetch,
  });
  const columns: ColumnType<RoleData>[] = useMemo(
    () => [
      {
        name: "ID",
        accessKey: "id",
        cell: (row) => (
          <span className="font-semibold text-gray-700">{row?.id}</span>
        ),
        sortable: true,
      },
      {
        name: "Name",
        accessKey: "name",

        cell: (row) => <><Tooltip description={row.name}>
              <div className="flex justify-start text-gray-800">
                <span className="text-start w-fit max-w-[150px] truncate">
                  {row.name}
                </span>
              </div>
            </Tooltip></>,
        sortable: true,
      },
      {
        name: "Permission",
        accessKey: "permission",
        sortable: false,

        cell: (row) => (
          <div className="space-x-2 flex gap-2 scroll-m-5 w-[300px] overflow-x-auto">
            {row.permissions.slice(0, 1)?.map((item, idx: number) => {
              return (
                <Badge
                  key={idx}
                  variant={"secondary"}
                  className="w-fit text-[#f0af1d] capitalize"
                >
                  {item.name}
                </Badge>
              );
            })}
            {row.permissions.length > 1 && (
              <Tooltip
                description={row?.permissions
                  .slice(1)
                  .map((item) => item.name)
                  .join(", ")}
              >
                <Badge
                  variant={"secondary"}
                  className="w-fit text-[#f0af1d] capitalize"
                >
                  +{row.permissions.length - 1}
                </Badge>
              </Tooltip>
            )}
          </div>
        ),
      },
      {
        name: "Actions",
        cell: (row) => (
          <div className="flex items-center gap-3 cursor-pointer font-[500] select-none">
            <button
              className="text-[#1DA077] cursor-pointer"
              onClick={() => handleAction({ type: "page-edit", data: row.id })}
              title="Edit"
            >
              Edit
            </button>
            <button
              className="text-[#C33241] cursor-pointer"
              onClick={() => {
                clearSelection();
                handleAction({
                  type: "confirm",
                  data: { type: "delete", id: row.id },
                });
              }}
              title="Delete"
            >
              Delete
            </button>
          </div>
        ),
        sortable: false,
      },
    ],
    [handleAction, clearSelection]
  );

  return columns;
};

export { ColumnList };
